import React, { useContext } from 'react';
import { Box, StatusIndicator } from '@amzn/awsui-components-core';
import { AppContext } from '../../contexts/AppContext';
import { convertEntities } from '@amzn/awscat-editor';

interface Props {
  input: string;
  minNum: number;
  maxNum: number;
}

const InputSizeMessage = ({ input, minNum, maxNum }: Props) => {
  const appContext = useContext(AppContext);
  const entities = appContext?.entities || {};
  const convertedInput = convertEntities(input, entities);
  const length = convertedInput?.length || 0;

  return length > maxNum || (length < minNum && length > 0) ? (
    <StatusIndicator type="warning" colorOverride="red">
      <Box variant="p" color="text-status-error" display="inline" fontSize="body-s">
        {`${minNum}-${maxNum} characters required`}
      </Box>
    </StatusIndicator>
  ) : (
    <Box variant="p" color="text-body-secondary" fontSize="body-s">
      {`${minNum}-${maxNum} characters required`}
    </Box>
  );
};

export default InputSizeMessage;
